<template>
  <div>
    <div class="col-sm-12 card">
      <div class="card-header">
        <h4 class="card-title">
          {{ inflow ? "Your" : "Credit" }} Order
          <span v-if="!inflow && credit" class="btn pull-right">Current Credit: {{ credit }}</span>
        </h4>
        <div v-if="inflow" class="category">
          Review your order
          {{ nothingToPay ? "" : "and pay using a credit or debit card below" }}
        </div>
        <div v-else class="category">
          Buy credit for your requests using a credit or debit card below
        </div>
      </div>

      <div v-loading="loading || paying" element-loading-spinner="qc-spinner" class="card-content row">
        <el-table class="table table-striped table-no-bordered" ref="paymentTable" :data="items" style="width: 100%"
          tooltip-effect="light">
          <el-table-column :min-width="300" :show-overflow-tooltip="true" label="Item">
            <template slot-scope="props">
              <span v-if="props.row.another">
                <button @click.prevent="$emit('newVerification')" type="button" class="btn btn-wd">
                  <i class="fa fa-plus"></i> Add another verification
                </button>
              </span>
              <span v-else-if="props.row.exact">
                {{ props.row.name }}
              </span>
              <span v-else-if="props.row.app">
                <div>
                  <strong>{{ props.row.name }}</strong>
                </div>
                {{ props.row.owner }}
              </span>
              <span v-else-if="!props.row.calc">
                <div>
                  <div>
                    <strong>{{ props.row.candidateName }}</strong>
                  </div>
                  <div v-for="name in props.row.instituteNames">
                    {{ name.name }}
                  </div>
                </div>
              </span>
            </template>
          </el-table-column>
          <el-table-column :width="40">
            <template slot-scope="props">
              <span v-if="!props.row.calc && !props.row.another && !props.row.app">
                <a v-if="!multi && !inview" class="btn btn-simple btn-info btn-xs btn-icon btn-warning" @click.prevent="$emit('editVerification', verifications[props.$index])"><i class="fa fa-pencil"></i></a>
                <a v-if="canRemove && verifications.length > 1"
                  class="btn btn-simple btn-info btn-xs btn-icon btn-danger"
                  @click.prevent="$emit('deleteVerification', props.$index)"><i class="fa fa-trash"></i></a>
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="inflow ? 'Our Price' : ''" :width="150" align="right">
            <template slot-scope="props">
              <div v-if="props.row.oldFee != null">
                <span v-if="props.row.oldFee && props.row.oldFee != props.row.fee"> <del>{{ formatMoney(props.row.oldFee) }}</del> </span>
                <span v-if="!props.row.calc && !props.row.another && !props.row.app">{{ formatMoney(props.row.fee) }}</span>
              </div>
              <div v-else>
                <span v-if="!props.row.calc && !props.row.another && !props.row.app">{{ formatMoney(props.row.fee) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="inflow ? 'Institute Surcharge' : ''" :width="175" align="right">
            <template slot-scope="props" v-if="$store.state.accreditationEnabled">
              <span v-if="!props.row.calc && !props.row.another && !props.row.app">{{ formatMoney(props.row.surcharge) }}</span>
            </template>
            <template slot-scope="props" v-else>
              <span v-if="!props.row.calc && !props.row.another && !props.row.app">{{ formatMoney(props.row.surcharge) }}</span>
              <span v-else-if="!props.row.exact && !props.row.another && !props.row.app">{{ props.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="$store.state.accreditationEnabled" :label="inflow ? 'Institute Accreditation' : ''" :width="175" align="right">
            <template slot-scope="props">
              <span v-if="!props.row.calc && !props.row.another && !props.row.app">{{ props.row.accreditation ? formatMoney(props.row.accreditation) : '-----'}}</span>
              <span v-else-if="!props.row.exact && !props.row.another && !props.row.app">{{ props.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Total" :width="200" align="right">
            <template slot-scope="props">
              <span v-if="props.row.app">{{ props.row.value }}</span>
              <span v-else-if="!props.row.calc && !props.row.another">{{ formatMoney(props.row.fee + props.row.surcharge + props.row.accreditation) }}</span>
              <span v-else-if="props.row.exact && !props.row.another">
                <el-tooltip class="item" :manual="true" :value="showCurrentCreditPopovers" effect="light"
                  content="Set extra credit to 0 in order to use your current credit" placement="left">
                  <el-input-number class="pull-right" v-model="toBuy" :min="min" :max="1000"></el-input-number>
                </el-tooltip>
              </span>
              <span v-else-if="props.row.curr">
                <el-popover ref="currentCreditPopover" placement="left" trigger="hover" :disabled="true"
                  @show="showCurrentCreditPopovers = true" @hide="showCurrentCreditPopovers = false" content="">
                </el-popover>
                <el-tooltip class="item" :manual="true" :value="showCurrentCreditPopovers" effect="light"
                  content="Current credit is not used when purchasing extra credit" placement="left">
                  <span v-show="toBuy > 0" v-popover:currentCreditPopover
                    class="btn btn-simple btn-xs btn-danger btn-icon" style="z-index: 1000"><i
                      class="fa fa-question"></i></span>
                </el-tooltip>
                <span :class="{ strikeThrough: toBuy > 0 }">{{ props.row.value }}</span>
              </span>
              <span v-else>
                {{ props.row.value }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <button v-if="multi && inflow && !inview && credit" @click.prevent="$emit('editMulti')" type="button"
          style="margin-bottom: 10px" class="btn btn-sm">
          <i class="fa fa-pencil"></i> Edit verifications</button><br />
        <button v-if="canAdd && inflow && !inview && credit" @click.prevent="$emit('newVerification')" type="button"
          class="btn btn-sm">
          <i class="fa fa-plus"></i> Add another verification
        </button>
      </div>
    </div>

    <transition name="el-fade-in-linear" mode="out-in">
      <div v-if="!nothingToPay" v-loading="loadingBt || paying" element-loading-spinner="qc-spinner" class="col-sm-12 card">
        <div class="card-header">
          <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon"
            v-if="this.accountCountry == 'Nigeria'">
            <span data-notify="icon" class="fa fa-exclamation"></span>
            <span data-notify="message" style="font-size: 130%">
              As your account is registered in Nigeria, please be aware of the following: locally issued Nigerian payment cards are currently
              limited in the amount they can transact via international payments. Where possible please use a non-Naira currency card or
              debit/credit card enabled for international transactions. If you have trouble making payment please try a different card(s).
            </span>
          </div>
          <h4 class="card-title">Payment Details</h4>
          <div class="category">
            Your credit or debit card details to pay for this order
          </div>
        </div>

        <div class="card-content row">
          <div v-loading="nothingToPay" element-loading-spinner="fa fa-check fa-3x"
            element-loading-text="Nothing to pay!" class="form-group">
            <div class="col-sm-12">
              <div id="dropin-container" />
              <p-checkbox class="pull-right" v-model="btSaveCard">Save card for later</p-checkbox>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div class="col-md-12 card card-plain">
      <button v-if="inflow" @click.prevent="$emit('payBack')" type="button" class="btn btn-wd btn-move-left">
        <span class="btn-label"><i class="ti-angle-left"></i></span>Back
      </button>
      <button @click.prevent="getBtNonce('pay')" type="button" v-bind:disabled="loadingBt || paying"
        v-bind:class="{ 'btn-disabled': loadingBt || paying }" class="btn btn-wd btn-fill btn-move-right pull-right">
        {{ nothingToPay ? "Next" : "Pay" }}<span class="btn-label"><i class="ti-angle-right"></i></span>
      </button>

      <button v-if="inflow && inview" @click.prevent="$emit('deleteVerification')" type="button" class="btn btn-wd">
        <i class="fa fa-trash"></i> Delete
      </button>
      <span v-if="inflow && inview" class="help-block">Completely delete this verification request as it is no longer
        needed.</span>
    </div>
  </div>
</template>

<script>
import accounting from "accounting";
import _ from 'lodash';
import LogRocket from 'logrocket'
import {version} from '../../../../package.json';
import axios from '../../../../src/http'

accounting.settings.currency.symbol = "£";

export default {
  name: "payment",

  props: {
    application: { type: Object, default: null },
    verifications: { type: Array, default: null },
    min: { type: Number, default: 1 },
    inflow: { type: Boolean, default: false },
    inview: { type: Boolean, default: false },
    multi: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: true,
      loadingBt: true,
      paying: false,
      toBuy: this.inflow ? 0 : 10,
      credit: null,
      vatPayer: false,
      btInstance: null,
      btNonce: null,
      btSaveCard: true,
      nothingToPay: false,
      showCurrentCreditPopovers: false,
      accountCountry: "",
      newFee: false,
    };
  },
  computed: {
    canAdd() {
      return !(this.application && this.application.lockedInstitutes);
    },
    canRemove() {
      return !(this.application && this.application.lockedInstitutes);
    },
    items() {
      var items = [];

      if (this.verifications) {
        this.verifications.forEach((verification, index) => {
          var instituteNames = null;
          if (this.$service.isEmp(verification.institute)) {
            instituteNames = [{ name: verification.institute.fields[0].value }];
            // } else if(this.$service.isHSC(verification.institute)) {
            //   instituteNames = [{name: verification.institute.fields[0].value}]
          } else {
            instituteNames =
              verification.institute.names &&
                verification.institute.names.length > 0
                ? verification.institute.names
                : [{ name: verification.institute.name }];
          }
          items.push({
            candidateName: verification.firstname + " " + verification.lastname,
            instituteNames: instituteNames,
            calc: false,
            oldFee: this.$store.state.hasDiscount ? this.$store.getters.preSalePrice(this.getVerificationPrice(verification, index)) : null,
            fee: this.getVerificationPrice(verification, index),
            surcharge: verification.institute.surcharge,
            accreditation: verification.accreditation ? verification.institute.accreditation : null
          });
        });
      }

      // if(this.application) {
      //     items.push({
      //       name: this.application.name,
      //       owner: this.application.owner.name,
      //       app: true,
      //       value: 'FREE'
      //     })
      // }

      // if(this.inflow) {
      //   items.push({
      //     another: true
      //   })
      // }

      if (!this.inflow) {
        items.push({
          name: this.inflow ? "Extra credit" : "Exact credit",
          exact: true,
          calc: true,
          min: this.min,
        });
      }

      if (
        this.inflow &&
        this.verifications &&
        this.verifications.length > 1 &&
        (this.vatPayer || accounting.unformat(this.credit) > 0)
      ) {
        items.push({
          name: "Sub total",
          calc: true,
          value: this.total,
        });
      }

      if (this.vatPayer) {
        items.push({
          name: "Plus VAT",
          calc: true,
          value: this.vat,
        });
      }

      if (this.inflow && accounting.unformat(this.credit) > 0) {
        items.push({
          name: "Less current credit",
          calc: true,
          curr: true,
          value: "(" + this.credit + ")",
        });
      }

      if (
        this.vatPayer ||
        (this.verifications && this.verifications.length > 1) ||
        (this.inflow && accounting.unformat(this.credit) > 0) ||
        !this.inflow
      ) {
        items.push({
          name: "Total",
          calc: true,
          value: this.totalToPay,
        });
      }

      return items;
    },
    verificationTotal() {
      let sumTotal = 0;
      if (this.verifications) {
        this.verifications.forEach((verification, index) => {
          if (verification.institute) {
            sumTotal += (this.getVerificationPrice(verification, index) + verification.institute.surcharge + (verification.accreditation ? verification.institute.accreditation : 0));
          }
        });
      }
      return sumTotal;
    },
    total() {
      return accounting.formatMoney(this.toBuy + this.verificationTotal);
    },
    vat() {
      return accounting.formatMoney(
        accounting.unformat(this.total) * (this.vatPayer ? 0.2 : 0)
      );
    },
    totalToPay() {
      var toPay =
        accounting.unformat(this.total) +
        accounting.unformat(this.vat) -
        (this.inflow && this.toBuy <= 0 ? accounting.unformat(this.credit) : 0);
      this.nothingToPay = toPay <= 0;
      return accounting.formatMoney(toPay > 0 ? toPay : 0);
    },
  },
  mounted() {
    this.setup();
    this.$api
      .getAccount()
      .then((response) => {
        this.accountData = response.data;
        this.accountCountry = this.accountData.company.addressCountry.name;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  watch: {
    toBuy(value) {
      if (!value) {
        this.toBuy = 1;
      }
      this.reSetup();
    },
  },
  methods: {
    getVerificationPrice(verification, index) {
      if (this.application && this.application.pricingScheme) {
        var scheme = this.application.pricingScheme
        var list = scheme[verification.institute.regionId]
        if(list == null) list = scheme['default']
        return this.getVerificationPriceFromList(list, index)
      } else {
        return verification.institute.product.price
      }
    },
    getVerificationPriceFromList(list, index) {
      if (list[index]) {
          return list[index];
        } else {
          return list[list.length - 1];
        }
    },
    formatMoney(value) {
      return accounting.formatMoney(value);
    },
    reSetup: _.debounce(function () {
        this.setup();
    }, 500),
    setup() {
      this.loadingBt = true
      var _this = this;
      this.$api
        .getCreditInfo()
        .then((response) => {
          this.credit = accounting.formatMoney(response.data.credit);
          this.btToken = response.data.btToken;
          this.vatPayer = response.data.vatPayer;
          this.totalToPay;
          if (!this.nothingToPay) {
            if (typeof braintree !== 'undefined') {
            braintree.dropin.create(
              {
                authorization: this.btToken,
                vaultManager: true,
                container: "#dropin-container",
                threeDSecure: true,
                paypal: this.$store.state.currency != 'GBP' ? null : {
                  flow: 'checkout',
                  amount: ''+ accounting.unformat(this.totalToPay),
                  currency: 'GBP'
                },
                googlePay: this.$store.state.currency != 'GBP' ? null : {
                  googlePayVersion: 2,
                  merchantId: 'BCR2DN6T56O63DIW',
                  transactionInfo: {
                    totalPriceStatus: 'FINAL',
                    totalPrice: ''+ accounting.unformat(this.totalToPay),
                    currencyCode: 'GBP',
                    countryCode: 'GB'
                  },
                  allowedPaymentMethods: [{
                    type: 'CARD',
                    parameters: {
                      // We recommend collecting and passing billing address information with all Google Pay transactions as a best practice.
                      billingAddressRequired: true,
                      billingAddressParameters: {
                        format: 'FULL'
                      }
                    }
                  }]
                }
              },
              function (createErr, instance) {
                if (createErr) {
                  if (createErr.message == "options.selector or options.container must reference a valid DOM node.") {
                    console.warn(createErr);
                  } else {
                    console.error(createErr);
                  }
                  _this.loading = false;
                  _this.loadingBt = false
                } else {
                  _this.btInstance = instance;
                  _this.btInstance.on('paymentMethodRequestable', function (event) {
                    if (event.type == 'AndroidPayCard' && event.paymentMethodIsSelected && !_this.paying) {
                      // The customer has completed the flow and we are ready to submit the payment method nonce to the server.
                      _this.getBtNonce('pay')
                    }
                  })
                  document.querySelector(
                    'div[data-braintree-id="postal-code-field-group"] > label > div[class="braintree-form__label"]'
                  ).innerHTML = "Postal Code / Zip Code";
                  _this.loading = false;
                  _this.loadingBt = false
                }
              }
            );
            } else {
              var logRocketEnv = null
                logRocketEnv = 'selective'
                LogRocket.init('omhnj3/qc-prod', {
                  release: version
                })
              axios.get('https://js.braintreegateway.com/web/dropin/1.32.0/js/dropin.min.js')
                .then(response => {
                  console.log(response.data);
                })
                .catch(error => {
                  this.$snotify.warning("Braintree, the third party which is used to process payments, has failed. Please try clearing your cache and then repeating payment. If the error persists please contact Qualification Check.", "Warning", {
                  timeout: 10000,
                  })
                  LogRocket.captureMessage('BRAINTREE FETCH FAIL', {
                    tags: {
                      // additional data to be grouped as "tags"
                      code: 'BFF',
                    },
                    extra: {
                      // additional arbitrary data associated with the event
                      page: 'Checkout',
                    },
                  });
                  console.log(error);
                });
            }
          } else {
            this.loading = false;
            this.loadingBt = false
          }

          this.paying = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getBtNonce(action) {
      this.paying = true;
      var _this = this;
      if (this.nothingToPay) {
        this.$emit(action, null, function (success) {
          if (!success) {
            _this.setup();
            _this.paying = false;
          }
        });
      } else {
        this.btInstance.requestPaymentMethod(
          {
            threeDSecure: {
              amount: accounting.unformat(this.totalToPay),
              email: this.$store.state.username,
            },
          },
          (err, payload) => {
            if (payload && payload.nonce) {
              this.$emit(
                action,
                {
                  amount: action === "pay" ? _this.toBuy : 0,
                  btNonce: payload.nonce,
                  btSaveCard: _this.btSaveCard,
                },
                function (success) {
                  if (!success) {
                    _this.setup();
                    _this.paying = false;
                  }
                }
              );
            } else {
              console.log("No BT payload or nonce returned!");
            }
            if (err) {
              console.error(err);
              _this.paying = false;
            }
          }
        );
      }
    },
  },
};
</script>

<style>
p.divider {
  display: flex;
  flex-direction: row;
}

p.divider * {
  flex-shrink: 0;
}

p.divider span.divider {
  width: 100%;
  flex-shrink: 1;
  border-bottom: 1px dotted black;
  margin: 5px;
}

.braintree-dropin label {
  width: 100%;
}

.strikeThrough {
  text-decoration: line-through;
}
</style>